import { Component } from '@angular/core';
import { AuthService } from '../../../../services/AuthService';
import { Router } from '@angular/router';
@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss','../Styles/shared.scss']
})
export class LoginComponent {
  email: string = '';
  password: string = '';
  errorMessage: string = '';

  constructor(private authService: AuthService, private router: Router) { }

  async onLogin() {
    try {
      await this.authService.signIn(this.email, this.password);
      this.router.navigate(['/attendance']); 
    } catch (error: any) {
      this.errorMessage = error.message || 'An error occurred. Please try again.';
    }
  }
}

